'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconKey, iconKeyTag } from '@ni/nimble-components/dist/esm/icons/key';
import { wrap } from '../../utilities/react-wrapper';

export type { IconKey };
export { iconKeyTag };
export const NimbleIconKey = wrap(IconKey);